const ccMonthReducer = (state = '', action) => {
	switch(action.type){
	case 'CCMONTHVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default ccMonthReducer;